/**
 * Home layout Z, "The app". The page works like the phone app: under the hero, the whole site is a
 * clip list where every row is something CherryClipz does (FeatureList, full mode: search, group
 * chips, group headers, the app's bottom bar). Three rows come pre-ticked so Play works at once.
 */
import React, { useMemo } from "react";
import { HOME3_CSS } from "./home3Css";
import { StoreBadges, UploadCard, useHomeFonts } from "./kit";
import { H3Footer, H3Nav, storeForThisPhone } from "./chrome";
import { FEATURES_CSS, FeatureList } from "./features";
import { APP_STORE_URL, NAV, Z, Z_FEATURES, Z_PRESET, storeLink } from "../../constants/homeLayoutsText";
import UploadBlock from "../../simple/UploadBlock";
import { UPLOAD_HERE_LABEL } from "../../constants/simpleHomeText";

const LayoutZPage: React.FC = () => {
  useHomeFonts();
  const store = useMemo(() => storeLink(storeForThisPhone() || APP_STORE_URL, "z-nav"), []);
  return (
    <div className="h3 dark h3-z">
      <style>{HOME3_CSS + FEATURES_CSS}</style>
      <H3Nav
        links={[
          { id: "z-list", label: Z.listTitle(Z_FEATURES.length).replace(" CherryClipz does", "") },
          { id: "z-web", label: NAV.web },
        ]}
        cta={{ label: NAV.getApp, onClick: () => window.open(store, "_blank", "noopener") }}
      />

      <section className="z-hero">
        <div className="wrap">
          <span className="eyebrow">{Z.eyebrow}</span>
          <h1>
            {Z.title1}
            <br />
            <span className="rw">{Z.title2}</span>
          </h1>
          <p className="lede">{Z.sub}</p>
          <div style={{ marginTop: 26 }}>
            <StoreBadges qr onDark tag="z-hero" />
          </div>
          <div className="z-up">
            <UploadBlock skin="dark" label={UPLOAD_HERE_LABEL} />
          </div>
        </div>
      </section>

      <section className="z-app" id="z-list">
        <div className="z-col">
          <FeatureList full preset={Z_PRESET} tag="z" />
        </div>
      </section>

      <section className="z-web" id="z-web">
        <div className="wrap z-web-grid">
          <div>
            <h2 className="h2">{Z.webTitle}</h2>
            <p className="lede" style={{ marginTop: 16 }}>
              {Z.webBody}
            </p>
          </div>
          <UploadCard />
        </div>
      </section>

      <H3Footer />
    </div>
  );
};

export default LayoutZPage;
